<template>
  <div>
    <tableComponent
      ref="tableComponent"
      :tableSettings="tableSettings"
      :tableData="tableData"
      :headers="headers"
      @newDocument="newDocument"
      @openMultiUserDialog="openMultiUserDialog"
      @goToTemplates="goToTemplates"
      @openBulkMove="openBulkMove"
      @confirmBulkProof="confirmBulkProof"
      @confirmBulkDelete="confirmBulkDelete"
      @openImport="openImport"
      @openUpload="uploadDialogOpen = true"
    />
    <riskAssessmentUploadDialog
      v-model="uploadDialogOpen"
      @saved="reloadDataFunc"
    />
    <riskAssessmentImportDialog
      :importDialog="importDialog"
      :loading="importing"
      @triggerUpload="importData"
    />
    <moveDialog
      :item="bulkMove.item"
      :moveDialog="bulkMove.dialog"
      :loading="bulkMove.loading"
      :array="bulkMove.targets"
      @cancel="bulkMove.dialog.open = false"
      @confirm="handleBulkMoveConfirm"
    />
    <v-dialog v-model="bulkProof.open" max-width="480">
      <v-card>
        <v-card-title>{{ $t("riskAssessment.bulk.proofTitle") }}</v-card-title>
        <v-card-text>
          <p class="mb-4">{{ bulkProof.message }}</p>
          <v-checkbox
            v-model="bulkProof.agree"
            :label="$t('riskAssessment.proof.agree')"
            hide-details
            class="mt-0"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="bulkProof.open = false"
            :disabled="bulkProof.loading"
          >
            {{ $t("general.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!bulkProof.agree"
            :loading="bulkProof.loading"
            @click="runBulkProof"
          >
            {{ $t("riskAssessment.proof.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bulkConfirm.open" max-width="440">
      <v-card>
        <v-card-title>{{ bulkConfirm.title }}</v-card-title>
        <v-card-text>{{ bulkConfirm.message }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="bulkConfirm.open = false"
            :disabled="bulkConfirm.loading"
          >
            {{ $t("general.cancel") }}
          </v-btn>
          <v-btn
            color="error"
            :loading="bulkConfirm.loading"
            @click="runBulkDelete"
          >
            {{ $t("riskAssessment.bulk.deleteButton") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="kindChooserOpen" max-width="800px">
      <v-card>
        <v-list>
          <v-list-item>
            <v-btn block color="primary" @click="newDocumentOfKind('basic')">
              {{ $t("riskAssessment.kind.basic") }}
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn block color="primary" @click="newDocumentOfKind('advanced')">
              {{ $t("riskAssessment.kind.advanced") }}
            </v-btn>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
    <multiUserDialog
      v-model="multiUserOpen"
      entityType="riskAssessment"
      :availableItems="transferItems"
      itemText="title"
      itemValue="_id"
      :clients="transferClients"
      :currentClientId="currentClientId"
      @confirm="executeTransfer"
      entityLabel="multiUser.dialog.riskAssessments"
    />
  </div>
</template>
<script>
import { getUniqueId } from "../../components/api/api";
import tableComponent from "../../components/_utils/dataTableHelpers/tableComponent.vue";
import multiUserDialog from "../../components/_utils/dataTableHelpers/actions/multiUserDialog.vue";
import moveDialog from "../../components/_utils/dataTableHelpers/actions/moveDialog.vue";
import riskAssessmentImportDialog from "./riskAssessmentImportDialog.vue";
import riskAssessmentUploadDialog from "./riskAssessmentUploadDialog.vue";

export default {
  components: {
    tableComponent,
    multiUserDialog,
    moveDialog,
    riskAssessmentImportDialog,
    riskAssessmentUploadDialog,
  },
  data: () => ({
    tableSettings: {
      title: "",
      showSelect: true,
      showHeaderToolbar: true,
      multipleSelectButtons: [
        {
          title: "riskAssessment.bulk.moveButton",
          color: "primary",
          action: "openBulkMove",
          icon: "content_paste_go",
          iconDark: true,
          dark: true,
          outlined: true,
        },
        {
          title: "riskAssessment.bulk.deleteButton",
          color: "error",
          action: "confirmBulkDelete",
          icon: "delete",
          iconDark: true,
          dark: true,
          outlined: true,
        },
      ],
      headerButtons: [
        {
          title: "riskAssessment.templates.manageTemplates",
          color: "primary",
          action: "goToTemplates",
          icon: "mdi-file-document-outline",
          iconDark: true,
          dark: true,
          outlined: true,
        },
        {
          title: "multiUser.button",
          color: "primary",
          action: "openMultiUserDialog",
          icon: "mdi-swap-horizontal",
          iconDark: true,
          dark: true,
        },
        {
          title: "riskAssessment.upload.button",
          color: "secondary",
          action: "openUpload",
          icon: "cloud_upload",
          iconDark: true,
          dark: true,
          outlined: true,
        },
        {
          title: "riskAssessment.import.button",
          color: "grey",
          action: "openImport",
          icon: "download",
          iconDark: true,
          dark: true,
          outlined: true,
        },
        {
          title: "riskAssessment.addRiskAssessment",
          color: "secondary",
          action: "newDocument",
          icon: "add",
          iconDark: true,
          dark: true,
          outlined: true,
        },
      ],
    },
    bulkMove: {
      item: {},
      loading: false,
      targets: [],
      ids: [],
      dialog: {
        open: false,
        title: "riskAssessment.bulk.moveTitle",
        description: "",
      },
    },
    bulkConfirm: {
      open: false,
      loading: false,
      title: "",
      message: "",
      ids: [],
    },
    importDialog: {
      open: false,
    },
    importing: false,
    currentClientId: "",
    currentUserId: "",
    proofers: [],
    bulkProof: {
      open: false,
      loading: false,
      agree: false,
      message: "",
      ids: [],
    },
    isMultiUser: false,
    canManageTemplates: false,
    templateSourceIds: [],
    multiUserOpen: false,
    kindChooserOpen: false,
    uploadDialogOpen: false,
    transferClients: [],
    transferItems: [],
  }),
  async created() {
    const user = await this.$store.dispatch("getUserInfo");
    this.currentClientId = user?.client?._id || "";
    this.currentUserId = user?._id || "";
    this.isMultiUser = user?.role === "MultiUser";

    const proofersSetting = await this.$store.dispatch("getProofers");
    this.proofers = (
      (proofersSetting && proofersSetting.value?.riskAssessment) ||
      []
    ).map(String);

    if (this.proofers.includes(String(this.currentUserId))) {
      this.tableSettings.multipleSelectButtons = [
        {
          title: "riskAssessment.bulk.proofButton",
          color: "primary",
          action: "confirmBulkProof",
          icon: "mdi-check-decagram",
          iconDark: true,
          dark: true,
          outlined: true,
        },
        ...this.tableSettings.multipleSelectButtons,
      ];
    }
    this.canManageTemplates = ["MultiUser", "Owner", "Admin"].includes(
      user?.role
    );

    const res = await this.$store.dispatch("getRiskAssessments", {
      riskAssessmentCategoryId: this.$route.params.riskAssessmentCategoryId,
    });
    this.transferItems = (res && res.data) || res || [];

    if (!this.isMultiUser) {
      this.tableSettings.headerButtons =
        this.tableSettings.headerButtons.filter(
          (btn) => btn.action !== "openMultiUserDialog"
        );
    }

    if (this.canManageTemplates) {
      this.loadTemplateSourceIds();
    }
    this.$root.$on("ra-template-added", this.loadTemplateSourceIds);
  },
  beforeDestroy() {
    this.$root.$off("ra-template-added", this.loadTemplateSourceIds);
  },
  computed: {
    filterItems() {
      const items = this.transferItems || [];
      const uniq = (arr) => [
        ...new Set(
          arr.filter((x) => x !== undefined && x !== null && x !== "")
        ),
      ];
      return {
        title: uniq(items.map((i) => i.title)).sort(),
        location: uniq(items.map((i) => i.location)).sort(),
        highRisk: [
          { text: this.$t("general.yes"), value: "yes" },
          { text: this.$t("general.no"), value: "no" },
        ],
      };
    },
    headers() {
      return [
        {
          text: this.$t("riskAssessment.tableHeader.riskAssessment"),
          value: "title",
          align: "left",
          filters: [
            { param: "title", items: this.filterItems.title, searchable: true },
          ],
        },
        {
          text: this.$t("riskAssessment.tableHeader.location"),
          value: "location",
          filters: [{ param: "location", items: this.filterItems.location }],
        },
        {
          text: this.$t("riskAssessment.tableHeader.riskAssessmentCount"),
          value: "risks.length",
        },
        {
          text: this.$t("riskAssessment.tableHeader.highRiskCount"),
          value: "riskAssessmentHighRiskCount",
          sortable: false,
          filters: [{ param: "highRisk", items: this.filterItems.highRisk }],
        },
        {
          text: this.$t("riskAssessment.tableHeader.kind"),
          value: "riskAssessmentKind",
          sortable: false,
        },
        {
          text: this.$t("riskAssessment.tableHeader.proofed"),
          value: "riskAssessmentProofed",
          sortable: false,
        },
        {
          text: "",
          value: "riskAssessmentAction",
          align: "right",
          sortable: false,
          width: 260,
        },
      ];
    },
    tableData() {
      return {
        tableComponentSlots: [
          {
            id: getUniqueId(),
            slotName: "item.riskAssessmentHighRiskCount",
            componentName: "riskAssessmentHighRiskCount",
          },
          {
            id: getUniqueId(),
            slotName: "item.riskAssessmentKind",
            componentName: "riskAssessmentKind",
          },
          {
            id: getUniqueId(),
            slotName: "item.riskAssessmentProofed",
            componentName: "riskAssessmentProofedStatus",
          },
          {
            id: getUniqueId(),
            slotName: "item.riskAssessmentAction",
            componentName: "riskAssessmentAction",
            config: {
              canManageTemplates: this.canManageTemplates,
              templateSourceIds: this.templateSourceIds,
              currentUserId: this.currentUserId,
              proofers: this.proofers,
            },
          },
        ],
        itemKey: "_id",
        uriPartPrepend: "riskAssessment",
        uriPartAppend: `&riskAssessmentCategory=${this.$route.params.riskAssessmentCategoryId}`,
        populate: [],
        sort: "-createdAt",
        editFormPushName: "riskAssessmentForm",
      };
    },
  },
  methods: {
    openImport() {
      this.importDialog.open = true;
    },
    async importData(file) {
      if (!file || !file.content) return;
      this.importing = true;
      try {
        await this.$store.dispatch("createRiskAssessmentImport", {
          file: file.content,
          riskAssessmentCategory: this.$route.params.riskAssessmentCategoryId,
        });
        this.importDialog.open = false;
        this.reloadDataFunc();
      } finally {
        this.importing = false;
      }
    },
    async openBulkMove(selectedItems) {
      this.bulkMove.ids = (selectedItems || []).map((i) => i._id);
      const res = await this.$store.dispatch("getAllRiskAssessmentCategories");
      const cats = (res && res.data) || res || [];
      this.bulkMove.targets = cats
        .map((c) => ({ id: c.id || c._id, name: c.name }))
        .filter(
          (t) =>
            String(t.id) !== String(this.$route.params.riskAssessmentCategoryId)
        );
      this.bulkMove.dialog.description = this.$t(
        "riskAssessment.bulk.moveText",
        { count: this.bulkMove.ids.length }
      );
      this.bulkMove.dialog.open = true;
    },
    async handleBulkMoveConfirm(targetId) {
      try {
        this.bulkMove.loading = true;
        await this.$store.dispatch("bulkMoveRiskAssessments", {
          ids: this.bulkMove.ids,
          riskAssessmentCategory: targetId,
        });
        this.bulkMove.dialog.open = false;
        this.onBulkActionDone();
      } finally {
        this.bulkMove.loading = false;
      }
    },
    proofableByMe(item) {
      const uid = String(this.currentUserId || "");
      if (!uid) return false;

      const versions = (item && item.versions) || [];
      if (!versions.length) return false;

      const version =
        versions.find((v) => v.version === item.currentVersion) ||
        versions[versions.length - 1];

      const isRequired = (version.requiredProofers || []).some(
        (rp) => String(rp.user) === uid
      );
      if (!isRequired) return false;

      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

      return !(version.proofs || []).some(
        (p) =>
          String(p.user) === uid &&
          new Date(p.proofedAt).getTime() >= oneYearAgo.getTime()
      );
    },
    confirmBulkProof(selectedItems) {
      const selected = selectedItems || [];
      const proofable = selected.filter((i) => this.proofableByMe(i));
      const ids = proofable.map((i) => i._id);

      if (!ids.length) {
        this.$store.dispatch(
          "triggerSnackbar",
          this.$t("riskAssessment.bulk.proofNothingToDo")
        );
        return;
      }

      const ignored = selected.length - ids.length;

      this.bulkProof = {
        open: true,
        loading: false,
        agree: false,
        message: ignored
          ? this.$t("riskAssessment.bulk.proofConfirmPartial", {
              count: ids.length,
              ignored,
            })
          : this.$t("riskAssessment.bulk.proofConfirm", {
              count: ids.length,
            }),
        ids,
      };
    },
    async runBulkProof() {
      this.bulkProof.loading = true;
      try {
        await this.$store.dispatch(
          "bulkProofRiskAssessments",
          this.bulkProof.ids
        );
        this.bulkProof.open = false;
        this.onBulkActionDone();
      } finally {
        this.bulkProof.loading = false;
      }
    },
    confirmBulkDelete(selectedItems) {
      const ids = (selectedItems || []).map((i) => i._id);
      this.bulkConfirm = {
        open: true,
        loading: false,
        title: this.$t("riskAssessment.bulk.deleteTitle"),
        message: this.$t("riskAssessment.bulk.deleteConfirm", {
          count: ids.length,
        }),
        ids,
      };
    },
    async runBulkDelete() {
      this.bulkConfirm.loading = true;
      try {
        await this.$store.dispatch(
          "bulkDeleteRiskAssessments",
          this.bulkConfirm.ids
        );
        this.bulkConfirm.open = false;
        this.onBulkActionDone();
      } finally {
        this.bulkConfirm.loading = false;
      }
    },
    onBulkActionDone() {
      if (this.$refs.tableComponent) {
        this.$refs.tableComponent.clearSelectItems();
      }
      this.reloadDataFunc();
    },
    goToTemplates() {
      this.$router.push({
        name: "riskAssessmentTemplates",
        query: {
          targetId: this.$route.params.riskAssessmentCategoryId,
          targetName: this.$route.params.riskAssessmentCategoryName,
        },
      });
    },
    async loadTemplateSourceIds() {
      const res = await this.$store.dispatch("getRiskAssessmentTemplates");
      const templates = (res && res.data) || [];
      this.templateSourceIds = templates
        .filter((t) => t.sourceRiskAssessment)
        .map((t) => String(t.sourceRiskAssessment));
    },
    reloadDataFunc() {
      this.$refs.tableComponent.getData();
    },
    newDocument() {
      this.kindChooserOpen = true;
    },
    newDocumentOfKind(kind) {
      this.kindChooserOpen = false;
      this.$router.push({
        name: this.tableData.editFormPushName,
        params: { id: "1", mode: "new", data: 1 },
        query: kind === "advanced" ? { kind } : {},
      });
    },
    deleteItem(item) {
      this.$store.dispatch("deleteMultipleRiskAssessment", item).then(() => {
        this.reloadDataFunc();
        this.multipleDeleteDialog.open = false;
        this.multipleDeleteDialog.items = [];
      });
    },

    async openMultiUserDialog() {
      try {
        const res = await this.$store.dispatch("getTransferClients");
        this.transferClients = res.data || [];
      } catch (e) {
        return;
      }
      this.multiUserOpen = true;
    },

    async executeTransfer(payload) {
      try {
        const result = await this.$store.dispatch("transferEntities", payload);

        const parts = [];
        if (result.totalSuccess > 0) {
          parts.push(
            this.$t("multiUser.result.success", {
              number: result.totalSuccess,
            })
          );
        }
        if (result.totalConflict > 0) {
          parts.push(
            this.$t("multiUser.result.error", {
              number: result.totalConflict,
            })
          );
        }
        if (result.totalError > 0) {
          parts.push(
            this.$t("multiUser.result.error", { number: result.totalError })
          );
        }

        this.$store.commit("CREATE_SNACKBAR", parts.join(" · "));

        if (payload.action === "move" && result.totalSuccess > 0) {
          this.reloadDataFunc();
        }
      } catch (e) {
        console.error("Transfer failed:", e);
      }
    },
  },
};
</script>
